import { AccountingLocationAnswer as WebAccountingLocationAnswer } from "WebServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers";
import { AccountingLocationAnswer as AdminAccountingLocationAnswer } from "AdminServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers";
import { useEnumAnswer } from "./answer-enum";
import { AccountingLocationAnswerValue } from "WebServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers/AccountingLocationAnswerAbstraction";
import i18next from "i18next";
export const observedAttributes = ["q11e", "questionId"];
export const useShadowDOM = false;
export const name = "ww-answer-accountinglocation";
export class AccountingLocationChangeChangeEvent extends CustomEvent {
  constructor(detail) {
    super("change", { detail, bubbles: true });
  }
}
export const Component = (host) => {
  const props = {
    q11e: host.q11e,
    questionId: host.questionId
  };
  const dispatch = (answer) => {
    host.dispatchEvent(
      new AccountingLocationChangeChangeEvent({
        answer: getAnswer(answer)
      })
    );
  };
  const getAnswer = (answer) => {
    var _a;
    if ((_a = props.q11e) == null ? void 0 : _a.isAdmin) {
      return new AdminAccountingLocationAnswer({ Value: answer.Value, QuestionId: props.questionId });
    }
    return new WebAccountingLocationAnswer({ Value: answer.Value, QuestionId: props.questionId });
  };
  const enumHook = useEnumAnswer({
    dataSource: [
      { value: AccountingLocationAnswerValue.AccountingOffice, label: i18next.t("Accounting office") },
      { value: AccountingLocationAnswerValue.Own, label: i18next.t("On your own") }
    ],
    isMultiSelect: false,
    questionId: props.questionId,
    q11e: props.q11e,
    dispatch
  });
  return enumHook.mainTemplate;
};
